import { Page, PageHeader } from "@/components/Bits";
import AccrualAccuracy from "@/components/AccrualAccuracy";

export default function AccrualAccuracyPage() {
  return (
    <Page>
      <PageHeader overline="Insights" title="Estimate Accuracy"
        subtitle="How close our recurring-accrual predictions were to the actual bills, month by month." />
      <AccrualAccuracy standalone />
    </Page>
  );
}
